import React, {useEffect, useState} from "react";
import Layout from "../layout/Layout";
import {url} from "../utils/UrlsUtil";
import {post} from "../utils/FetchUtil";
import {useLoading} from "../components/loading/LoadingProvider";
import TemplateTypeChoiceModal from "../modal/TemplateTypeChoiceModal";
import "../../style/template/my_template_page.scss";
import {Link, useNavigate} from "react-router-dom";
import {
    TEMPLATE_KBN_GIFT_MESSAGE,
    TEMPLATE_TYPE_WRAPPING
} from "../const/TemplateConst.ts";
import {Button, Card, CardImg, Col, Image, Row} from "react-bootstrap";
import OptionTemplateItem from "../components/list/OptionTemplateItem.tsx";
import {img} from "../utils/ImageUtil.ts";
import {popConfirm} from "../utils/MessageUtil.ts";
import {useAuth} from "../components/auth/AuthProvider.tsx";

interface TemplateListForm{
    message_templates: OrderInputTemplateDto[];
    noshi_templates: OrderInputTemplateDto[];
    card_templates: OrderInputTemplateDto[];
}

const TemplatePage:React.FC = () => {
    const breadcrumbList = ["マイデザインの製作"];
    const { loginDto } = useAuth();
    const [errorList, setErrorList] = useState([]);
    const { showLoading, hideLoading } = useLoading();
    const navigate = useNavigate();
    const [templateListForm, setTemplateListForm] = useState<TemplateListForm | null | undefined>();
    const [showTypeChoiceModal, setShowTypeChoiceModal] = useState(false);
    const [selectedType, setSelectedType] = useState<string>("");
    useEffect(() => {
        getTemplateListInfo();
    }, [loginDto]);
    useEffect(() => {
        getTemplateListInfo();
    }, [])
    const getTemplateListInfo = () =>{
        showLoading();
        post<TemplateListForm>({
            action: "/api/template/info",
            data: {}
        })
            .then((data) => {
                setTemplateListForm(data);
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    }
    const handleClickInputTemp = (type: string) => {
        setSelectedType(type);
        setShowTypeChoiceModal(true);
    }
    const handleSelectedTemplate = (template_kbn: string) => {
        navigate("/template/input/" + template_kbn);
    }
    const handleDeleteTemplate = (template_id: number | undefined) => {
        if(template_id === undefined) {
            return;
        }
        showLoading();
        post<TemplateListForm>({
            action: "/api/template/delete",
            data: {template_id : template_id},
        })
            .then(() => {
                getTemplateListInfo();
            })
            .catch((reason) => {
                // @ts-ignore
                setErrorList([reason.message]);
            })
            .finally(() => {
                hideLoading();
            });
    }
    const onClickDeleteTemplate = (template_id: number | undefined) => {
        if(template_id !== undefined){
            popConfirm(
                "マイデザインを削除します。よろしいですか？",
                () => {handleDeleteTemplate(template_id);}
            );
        }
    }

    return (
      <Layout page_meta = {{title: 'マイデザインの製作｜ギフトアレンジ'}}
              breadcrumb_list={breadcrumbList}
              error_list={errorList}
              page_class={"my-template-page"}
      >
          <section className="template-info-title">
              <h2>
                  マイデザインの製作
              </h2>
              <p style={{letterSpacing: 0}}>
                  マイデザインを作成後、<br/>
                  〇 のし・包装紙の場合は、【<Link to="/order/input">未発送のご注文</Link>】<br className="sp"/>より割り当てください。<br/>
                  〇 オンラインメッセージは発送済みでも<br className="sp"/>割り当てできるため、<br/>【<Link to="/order/input">未発送のご注文</Link>】または<br className="sp"/>【<Link to="/order/history">過去のご注文</Link>】から割り当ててください。<br/>
              </p>
          </section>
          <section className="templates-area">
              <Row gutter={0}>
                  <Col xs={12} md={8}>
                      {/*オンライン・メッセージテンプレート入力*/}
                      <div className={"template-input-block"}>
                          <div className={"template-title"}>
                              <span className="type-icon"><img src={url("/images/icon/message_icon.png")}/></span>オンライン・メッセージ
                          </div>
                          <Button variant="info"
                                  onClick={() => navigate(`/template/input/${TEMPLATE_KBN_GIFT_MESSAGE}`)}
                          >
                              マイデザイン作成<span className="button-icon"><img src={url("/images/icon/pen_white_icon.png")}/></span>
                          </Button>
                      </div>
                      {templateListForm?.message_templates && templateListForm?.message_templates.length > 0 && <div className={"template-list online-messages"}>
                          {templateListForm.message_templates.map((templateDto, idx) => <OptionTemplateItem
                              key={`online_msg_tmp_itm_${idx}`}
                              template_dto={templateDto}
                              showTitle={true}
                              showDeleteButton={true}
                              handleDelete={() => {handleDeleteTemplate(templateDto.template_id)}}
                          ></OptionTemplateItem>)}
                      </div>}
                      {/*のし・包装テンプレート入力*/}
                      <div className={"template-input-block"}>
                          <div className={"template-title"}>
                              <span className="type-icon"><img src={url("/images/icon/wrap_icon.png")}/></span>のし・包装（無料）
                          </div>
                          <Button variant="info"
                                  onClick={() => handleClickInputTemp(TEMPLATE_TYPE_WRAPPING)}>
                              マイデザイン作成<span className="button-icon"><img src={url("/images/icon/pen_white_icon.png")}/></span>
                          </Button>
                      </div>
                      {templateListForm?.noshi_templates && templateListForm?.noshi_templates.length > 0 && <div className={"template-list"}>
                          {templateListForm.noshi_templates.map((templateDto, idx) => <OptionTemplateItem
                              key={`wrap_template_list_itm_${idx}`} template_dto={templateDto}
                              showTitle={true}
                              showDeleteButton={true}
                              handleDelete={() => {handleDeleteTemplate(templateDto.template_id)}}
                          ></OptionTemplateItem>)}
                      </div>}
                  </Col>
                  <Col xs={12} md={4}>
                      {/*オリジナルカードテンプレート入力*/}
                      <div className={"template-input-block ondemand-cards"}>
                          <div className={"template-title"}>
                              <span className="type-icon"><img src={url("/images/icon/original_icon.png")}/></span>オリジナルギフトカード
                          </div>
                          <Button variant="info"
                                  onClick={() => navigate("/mydesign/card/")}>
                              マイデザイン作成<span className="button-icon"><img src={url("/images/icon/pen_white_icon.png")}/></span>
                          </Button>
                      </div>
                      {templateListForm?.card_templates && templateListForm?.card_templates.length > 0 && <div className={"template-list ondemand-cards"}>
                          {templateListForm.card_templates.map((templateDto, idx) => <Card
                              key={`ondemand_card_list_itm_${idx}`}
                              className={"template-list-item ondemand-card-item"}
                          >
                              <CardImg
                                  variant={"top"}
                                  // @ts-ignore
                                  src={img(templateDto.image_path)} />
                              <Image className="template-delete-btn"
                                     src={url('/images/icon/close_icon.png')}
                                     onClick={()=>{onClickDeleteTemplate(templateDto.template_id)}}
                              ></Image>
                          </Card>)}
                      </div>}
                  </Col>
              </Row>
          </section>
          <section>
              <TemplateTypeChoiceModal
                  type={selectedType}
                  show={showTypeChoiceModal}
                  handleClosed={()=>{setShowTypeChoiceModal(false)}}
                  handleSelected={handleSelectedTemplate}
              ></TemplateTypeChoiceModal>
          </section>
      </Layout>
    );
};
export default TemplatePage;
